import React, { Component } from 'react'
import { Col, Form } from 'antd'
import { get } from 'lodash'
import OrganisationsSelect from '../../../../elements/Select/Organistaions'
import ClientsListSelect from '../../../../elements/Select/Client/ClientsSelect'

class FilterForm extends Component {
  render() {
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 15 },
      },
    }
    const { getFieldDecorator } = this.props.form
    const { onChangeCompany, onChangeContract, ContractsSelectCmp, onChangeClient } = this.props
    return (
      <Form>
        <Col span={12}>
          <Form.Item {...formItemLayout} label={'Select a Company'}>
            {getFieldDecorator('company._id', {
              rules: [{ required: true, message: 'Please Select a Company!' }],
            })(<OrganisationsSelect onChange={onChangeCompany} />)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...formItemLayout} label={'Select a Client'}>
            {getFieldDecorator('client._id', {
              rules: [{ required: true, message: 'Please Select a Client!' }],
            })(
              <ClientsListSelect
                placeholder={'Select a Client'}
                keyAtr={'_id'}
                valueAtr={'fn'}
                onChange={onChangeClient}
              />
            )}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...formItemLayout} label={'Select a Contract '}>
            {getFieldDecorator('contract._id', {
              rules: [{ required: true, message: 'Please Select a Contract!' }],
            })(
              <ContractsSelectCmp
                keyAtr={'_id'}
                valueAtr={'title'}
                placeholder={'Contracts Account'}
                onChange={onChangeContract}
              />
            )}
          </Form.Item>
        </Col>
      </Form>
    )
  }
}

FilterForm.propTypes = {}
FilterForm.defaultProps = {}

export default Form.create()(FilterForm)
